import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NewgalleriesComponent } from './newgalleries.component'

const routes: Routes = [
  { path: '', component: NewgalleriesComponent },
  { path: ':id', component: NewgalleriesComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewgalleriesRoutingModule { }
